import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import { addCameraPermissionMutation } from "../mutations";
import { accessManagementQuery } from "../queries";

/**
 * Hook to grant a camera role to a user in the current tenant.
 * Automatically invalidates the access management query on success.
 *
 * @example
 * ```tsx
 * const { mutate, isPending } = useAddCameraPermission();
 *
 * const handleGrant = () => {
 *   mutate({ user: userId, camera: cameraId, role: "camera_viewer" });
 * };
 * ```
 */
export function useAddCameraPermission() {
  const apiConfig = useApiConfig();
  const queryClient = useQueryClient();

  const mutationApiConfig = {
    tenantId: apiConfig.tenant?.tenantId,
    apiBaseUrl: apiConfig.tenant?.apiBaseUrl,
    authenticatedFetch: apiConfig.authenticatedFetch,
  };

  return useMutation({
    ...addCameraPermissionMutation(mutationApiConfig, {}),
    onSuccess: () => {
      const queryKey = accessManagementQuery(apiConfig, {}).queryKey;
      void queryClient.invalidateQueries({ queryKey });
    },
  });
}
